var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fragment"},[_c('span',{staticClass:"fragment__title"},[_vm._v(_vm._s(_vm.title))]),_vm._t("default"),_c('button',{staticClass:"fragment__remove",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('remove')}}},[_vm._v("Убрать")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }